/*
 * Today on the Farm theme behaviour: the field bag (backed by Shopify's
 * AJAX cart), the mobile menu, the product page quantity and variant
 * picker, and the shop filters. Ported from the prototype's cart.js.
 */
(() => {
  const cfg = window.totf || { routes: { cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js' } };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  const money = (cents) =>
    new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);
  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const cart = $('[data-cart]');
  const scrim = $('[data-cart-scrim]');

  const render = (state) => {
    $$('[data-cart-count]').forEach((el) => (el.textContent = state.item_count));
    const box = $('[data-cart-items]');
    if (!box) return;
    box.innerHTML = state.items.length
      ? state.items
          .map((item) => {
            const img = item.image ? `<img src="${item.image}${item.image.includes('?') ? '&' : '?'}width=150" alt="" width="75" height="75">` : '<span class="cart-item-blank"></span>';
            const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-variant">${escapeHtml(item.variant_title)}</p>` : '';
            return `<article class="cart-item">${img}<div><h3>${escapeHtml(item.product_title)}</h3>${variant}<p>${money(item.final_price)} · Qty ${item.quantity}</p><button type="button" data-remove="${item.key}">Remove</button></div><strong>${money(item.final_line_price)}</strong></article>`;
          })
          .join('')
      : '<p class="empty-cart">Your field bag is waiting for something good.</p>';
    const subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(state.total_price);
    const checkout = $('[data-checkout]');
    if (checkout) checkout.toggleAttribute('hidden', state.item_count === 0);
  };

  const refresh = () => fetch(`${cfg.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()).then(render);

  const open = () => {
    if (!cart) return;
    cart.classList.add('open');
    scrim.classList.add('show');
    cart.setAttribute('aria-hidden', 'false');
    $('[data-cart-close]', cart)?.focus();
  };
  const close = () => {
    if (!cart) return;
    cart.classList.remove('open');
    scrim.classList.remove('show');
    cart.setAttribute('aria-hidden', 'true');
  };

  const add = async (button, variantId, quantity) => {
    button.disabled = true;
    const label = button.innerHTML;
    try {
      const res = await fetch(cfg.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity }] }),
      });
      const body = await res.json();
      if (!res.ok) throw new Error(body.description || body.message || 'Could not add that to the bag.');
      await refresh();
      open();
    } catch (err) {
      const note = button.closest('form, .product-meta')?.querySelector('[data-cart-error]');
      if (note) note.textContent = err.message;
      else alert(err.message);
    } finally {
      button.disabled = false;
      button.innerHTML = label;
    }
  };

  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      const form = addBtn.closest('[data-product-form]');
      const variantId = form ? $('[name="id"]', form).value : addBtn.dataset.variantId;
      const qty = form ? Number($('[data-quantity]', form).value || 1) : 1;
      add(addBtn, variantId, qty);
      return;
    }
    if (e.target.closest('[data-cart-open]')) {
      if (!cart) return;
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-cart-close]') || e.target === scrim) close();

    const remove = e.target.closest('[data-remove]');
    if (remove) {
      fetch(cfg.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: remove.dataset.remove, quantity: 0 }),
      })
        .then((r) => r.json())
        .then(render);
    }

    const step = e.target.closest('[data-quantity-plus], [data-quantity-minus]');
    if (step) {
      const out = $('[data-quantity]', step.closest('[data-product-form]'));
      const next = Number(out.value) + (step.hasAttribute('data-quantity-plus') ? 1 : -1);
      out.value = Math.max(1, next);
    }

    const menuToggle = e.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      const openNow = menuToggle.getAttribute('aria-expanded') !== 'true';
      menuToggle.setAttribute('aria-expanded', String(openNow));
      $('[data-menu]')?.classList.toggle('open', openNow);
    }

    const filter = e.target.closest('[data-filter]');
    if (filter) {
      const value = filter.dataset.filter;
      $$('[data-filter]').forEach((b) => b.classList.toggle('active', b === filter));
      $$('.product-grid .product-card').forEach((card) => {
        card.hidden = value !== 'all' && card.dataset.category !== value;
      });
      const count = $('[data-filter-count]');
      if (count) count.textContent = $$('.product-grid .product-card:not([hidden])').length;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });

  // Variant picker: match the chosen options to a variant, update price and button.
  $$('[data-product-form]').forEach((form) => {
    const dataEl = $('[data-variants]', form);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = $('[name="id"]', form);
    const price = $('[data-price]', form);
    const button = $('[data-add-to-cart]', form);
    const update = () => {
      const chosen = $$('[data-option]', form).map((el) => (el.tagName === 'SELECT' ? el.value : $('input:checked', el)?.value));
      const match = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
      if (!match) {
        button.disabled = true;
        button.textContent = 'Unavailable';
        return;
      }
      idInput.value = match.id;
      if (price) price.textContent = money(match.price);
      button.disabled = !match.available;
      button.innerHTML = match.available ? 'Add to field bag →' : 'Currently sold out';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    };
    form.addEventListener('change', (e) => {
      if (e.target.closest('[data-option]')) update();
    });
  });

  refresh().catch(() => {});
})();
